import React from 'react';
import ProductCatalog from '../components/ProductCatalog';
import ProductGallery from '../components/ProductGallery';

const Products = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-orange-50 via-white to-orange-50 py-20 lg:py-32">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 mb-6">
              Our <span className="text-orange-600">Product Range</span>
            </h1>
            <p className="text-lg lg:text-xl text-gray-600 leading-relaxed">
              Comprehensive selection of specialty adhesive tapes engineered for excellence
            </p>
          </div>
        </div>
      </section>

      {/* Product Gallery */}
      <section className="py-0">
        <ProductGallery />
      </section>

      {/* Product Catalog */}
      <section className="py-20 lg:py-28 bg-white">
        <div className="container mx-auto px-4 lg:px-8">
          <ProductCatalog />
        </div>
      </section>
    </div>
  );
};

export default Products;